import { createRouter, createWebHistory } from 'vue-router'
import FormularioInicial from '@/views/FormularioInicial.vue'
import FormularioFinal from '@/views/FormularioFinal.vue'
import PaginaNaoEncontrada from '@/views/PaginaNaoEncontrada.vue'
import { useInteresseStore } from "@/store/interesse";

const routes = [
    
    {
        path: '/:ns',
        props: true,
        name: 'FormularioInicial',
        component: FormularioInicial   
    },
    {
        path: '/:ns/final',
        props: true,
        name: 'FormularioFinal',        
        meta: { Autorizacao: true },
        component: FormularioFinal    
    },
    {
        path: '/:catchAll(.*)*',
        component: PaginaNaoEncontrada 
    }
    
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to) => {

    if (to.name == 'FormularioFinal') {        
        if (to.meta.Autorizacao) {
            const uInteresseStore = useInteresseStore();
            
            if (uInteresseStore.Autorizado) {
                uInteresseStore.Autorizado = false;
                return true
            }
            else {
                uInteresseStore.Autorizado = false;
                return window.history.back();
            }
        }
    }
})

export default router